const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "content": "min-w-32 max-h-(--reka-dropdown-menu-content-available-height) bg-default shadow-lg rounded-md ring ring-default overflow-hidden data-[state=open]:animate-[scale-in_100ms_ease-out] data-[state=closed]:animate-[scale-out_100ms_ease-in] origin-(--reka-dropdown-menu-content-transform-origin) flex flex-col",
    "input": "border-b border-default",
    "empty": "text-center text-muted",
    "viewport": "relative divide-y divide-default scroll-py-1 overflow-y-auto flex-1",
    "arrow": "fill-bg stroke-default",
    "group": "p-1 isolate",
    "label": "w-full flex items-center font-semibold text-highlighted",
    "separator": "-mx-1 my-1 h-px bg-border",
    "item": "group relative w-full flex items-start select-none outline-none before:absolute before:z-[-1] before:inset-px before:rounded-md data-disabled:cursor-not-allowed data-disabled:opacity-75",
    "itemLeadingIcon": "shrink-0",
    "itemLeadingAvatar": "shrink-0",
    "itemLeadingAvatarSize": "",
    "itemTrailing": "ms-auto inline-flex gap-1.5 items-center",
    "itemTrailingIcon": "shrink-0",
    "itemTrailingKbds": "hidden lg:inline-flex items-center shrink-0",
    "itemTrailingKbdsSize": "",
    "itemWrapper": "flex-1 flex flex-col text-start min-w-0",
    "itemLabel": "truncate",
    "itemDescription": "truncate text-muted",
    "itemLabelExternalIcon": "inline-block size-3 align-top text-dimmed"
  },
  "variants": {
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "red": "",
      "orange": "",
      "amber": "",
      "yellow": "",
      "green": "",
      "emerald": "",
      "teal": "",
      "cyan": "",
      "blue": "",
      "indigo": "",
      "purple": "",
      "pink": "",
      "neutral": ""
    },
    "active": {
      "true": {
        "item": "text-highlighted before:bg-elevated",
        "itemLeadingIcon": "text-default"
      },
      "false": {
        "item": [
          "text-default data-highlighted:text-highlighted data-[state=open]:text-highlighted data-highlighted:before:bg-elevated/50 data-[state=open]:before:bg-elevated/50",
          "transition-colors before:transition-colors"
        ],
        "itemLeadingIcon": [
          "text-dimmed group-data-highlighted:text-default group-data-[state=open]:text-default",
          "transition-colors"
        ]
      }
    },
    "loading": {
      "true": {
        "itemLeadingIcon": "animate-spin"
      }
    },
    "size": {
      "xs": {
        "label": "p-1 text-xs gap-1",
        "item": "p-1 text-xs gap-1",
        "empty": "p-2 text-xs",
        "itemLeadingIcon": "size-4",
        "itemLeadingAvatarSize": "3xs",
        "itemTrailingIcon": "size-4",
        "itemTrailingKbds": "gap-0.5",
        "itemTrailingKbdsSize": "sm"
      },
      "sm": {
        "label": "p-1.5 text-xs gap-1.5",
        "item": "p-1.5 text-xs gap-1.5",
        "empty": "p-2.5 text-xs",
        "itemLeadingIcon": "size-4",
        "itemLeadingAvatarSize": "3xs",
        "itemTrailingIcon": "size-4",
        "itemTrailingKbds": "gap-0.5",
        "itemTrailingKbdsSize": "sm"
      },
      "md": {
        "label": "p-1.5 text-sm gap-1.5",
        "item": "p-1.5 text-sm gap-1.5",
        "empty": "p-2.5 text-sm",
        "itemLeadingIcon": "size-5",
        "itemLeadingAvatarSize": "2xs",
        "itemTrailingIcon": "size-5",
        "itemTrailingKbds": "gap-0.5",
        "itemTrailingKbdsSize": "md"
      },
      "lg": {
        "label": "p-2 text-sm gap-2",
        "item": "p-2 text-sm gap-2",
        "empty": "p-3 text-sm",
        "itemLeadingIcon": "size-5",
        "itemLeadingAvatarSize": "2xs",
        "itemTrailingIcon": "size-5",
        "itemTrailingKbds": "gap-1",
        "itemTrailingKbdsSize": "md"
      },
      "xl": {
        "label": "p-2 text-base gap-2",
        "item": "p-2 text-base gap-2",
        "empty": "p-3 text-base",
        "itemLeadingIcon": "size-6",
        "itemLeadingAvatarSize": "xs",
        "itemTrailingIcon": "size-6",
        "itemTrailingKbds": "gap-1",
        "itemTrailingKbdsSize": "lg"
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-primary data-highlighted:text-primary data-highlighted:before:bg-primary/10 data-[state=open]:before:bg-primary/10",
        "itemLeadingIcon": "text-primary/75 group-data-highlighted:text-primary group-data-[state=open]:text-primary"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-secondary data-highlighted:text-secondary data-highlighted:before:bg-secondary/10 data-[state=open]:before:bg-secondary/10",
        "itemLeadingIcon": "text-secondary/75 group-data-highlighted:text-secondary group-data-[state=open]:text-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-success data-highlighted:text-success data-highlighted:before:bg-success/10 data-[state=open]:before:bg-success/10",
        "itemLeadingIcon": "text-success/75 group-data-highlighted:text-success group-data-[state=open]:text-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-info data-highlighted:text-info data-highlighted:before:bg-info/10 data-[state=open]:before:bg-info/10",
        "itemLeadingIcon": "text-info/75 group-data-highlighted:text-info group-data-[state=open]:text-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-warning data-highlighted:text-warning data-highlighted:before:bg-warning/10 data-[state=open]:before:bg-warning/10",
        "itemLeadingIcon": "text-warning/75 group-data-highlighted:text-warning group-data-[state=open]:text-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-error data-highlighted:text-error data-highlighted:before:bg-error/10 data-[state=open]:before:bg-error/10",
        "itemLeadingIcon": "text-error/75 group-data-highlighted:text-error group-data-[state=open]:text-error"
      }
    },
    {
      "color": "red" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-red data-highlighted:text-red data-highlighted:before:bg-red/10 data-[state=open]:before:bg-red/10",
        "itemLeadingIcon": "text-red/75 group-data-highlighted:text-red group-data-[state=open]:text-red"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-orange data-highlighted:text-orange data-highlighted:before:bg-orange/10 data-[state=open]:before:bg-orange/10",
        "itemLeadingIcon": "text-orange/75 group-data-highlighted:text-orange group-data-[state=open]:text-orange"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-amber data-highlighted:text-amber data-highlighted:before:bg-amber/10 data-[state=open]:before:bg-amber/10",
        "itemLeadingIcon": "text-amber/75 group-data-highlighted:text-amber group-data-[state=open]:text-amber"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-yellow data-highlighted:text-yellow data-highlighted:before:bg-yellow/10 data-[state=open]:before:bg-yellow/10",
        "itemLeadingIcon": "text-yellow/75 group-data-highlighted:text-yellow group-data-[state=open]:text-yellow"
      }
    },
    {
      "color": "green" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-green data-highlighted:text-green data-highlighted:before:bg-green/10 data-[state=open]:before:bg-green/10",
        "itemLeadingIcon": "text-green/75 group-data-highlighted:text-green group-data-[state=open]:text-green"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-emerald data-highlighted:text-emerald data-highlighted:before:bg-emerald/10 data-[state=open]:before:bg-emerald/10",
        "itemLeadingIcon": "text-emerald/75 group-data-highlighted:text-emerald group-data-[state=open]:text-emerald"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-teal data-highlighted:text-teal data-highlighted:before:bg-teal/10 data-[state=open]:before:bg-teal/10",
        "itemLeadingIcon": "text-teal/75 group-data-highlighted:text-teal group-data-[state=open]:text-teal"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-cyan data-highlighted:text-cyan data-highlighted:before:bg-cyan/10 data-[state=open]:before:bg-cyan/10",
        "itemLeadingIcon": "text-cyan/75 group-data-highlighted:text-cyan group-data-[state=open]:text-cyan"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-blue data-highlighted:text-blue data-highlighted:before:bg-blue/10 data-[state=open]:before:bg-blue/10",
        "itemLeadingIcon": "text-blue/75 group-data-highlighted:text-blue group-data-[state=open]:text-blue"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-indigo data-highlighted:text-indigo data-highlighted:before:bg-indigo/10 data-[state=open]:before:bg-indigo/10",
        "itemLeadingIcon": "text-indigo/75 group-data-highlighted:text-indigo group-data-[state=open]:text-indigo"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-purple data-highlighted:text-purple data-highlighted:before:bg-purple/10 data-[state=open]:before:bg-purple/10",
        "itemLeadingIcon": "text-purple/75 group-data-highlighted:text-purple group-data-[state=open]:text-purple"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "active": false,
      "class": {
        "item": "text-pink data-highlighted:text-pink data-highlighted:before:bg-pink/10 data-[state=open]:before:bg-pink/10",
        "itemLeadingIcon": "text-pink/75 group-data-highlighted:text-pink group-data-[state=open]:text-pink"
      }
    },
    {
      "color": "primary" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-primary before:bg-primary/10",
        "itemLeadingIcon": "text-primary"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-secondary before:bg-secondary/10",
        "itemLeadingIcon": "text-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-success before:bg-success/10",
        "itemLeadingIcon": "text-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-info before:bg-info/10",
        "itemLeadingIcon": "text-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-warning before:bg-warning/10",
        "itemLeadingIcon": "text-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-error before:bg-error/10",
        "itemLeadingIcon": "text-error"
      }
    },
    {
      "color": "red" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-red before:bg-red/10",
        "itemLeadingIcon": "text-red"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-orange before:bg-orange/10",
        "itemLeadingIcon": "text-orange"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-amber before:bg-amber/10",
        "itemLeadingIcon": "text-amber"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-yellow before:bg-yellow/10",
        "itemLeadingIcon": "text-yellow"
      }
    },
    {
      "color": "green" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-green before:bg-green/10",
        "itemLeadingIcon": "text-green"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-emerald before:bg-emerald/10",
        "itemLeadingIcon": "text-emerald"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-teal before:bg-teal/10",
        "itemLeadingIcon": "text-teal"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-cyan before:bg-cyan/10",
        "itemLeadingIcon": "text-cyan"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-blue before:bg-blue/10",
        "itemLeadingIcon": "text-blue"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-indigo before:bg-indigo/10",
        "itemLeadingIcon": "text-indigo"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-purple before:bg-purple/10",
        "itemLeadingIcon": "text-purple"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "active": true,
      "class": {
        "item": "text-pink before:bg-pink/10",
        "itemLeadingIcon": "text-pink"
      }
    }
  ],
  "defaultVariants": {
    "size": "md" as typeof size[number]
  }
}